import {
  Box, Container,
  Grid2
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import OrderSummary from "../../components/OrderSummary/OrderSummary";
import Address from "../../components/address/address";
import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";
import { createOrder } from "../../redux/orderSlice";
import { handlePayment } from "../../utilities/paymentUtils";
import "./ConfirmOrder.css";

const HEIGHT = window.innerHeight;
const WIDTH = window.innerWidth;

const ConfirmOrder = () => {
  const [addressId, setAddressId] = useState(null);
  const [cartData, setCartData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const location = useLocation();
  const cartId = location.state.cartId;

  useEffect(() => {
    // Retrieve and parse the cart data from session storage
    const customercarts: any = JSON.parse(localStorage.getItem("customercarts")!);
    const savedCart: any = customercarts!.find((x: any) => x.cartId == cartId);
    if (savedCart) {
      setCartData(savedCart.cartItems);
    }
  }, []);

  const setDeliveryAddress = async (addressId: any) => {
    setAddressId(addressId);
  }

  const placeOrder = async () => {
    if (addressId) {
      const totalAmount = cartData ? cartData.reduce((sum, item: any) => sum + item.totalPrice, 0) : 0.00;
      const salePrice = cartData ? cartData.reduce((sum, item: any) => sum + item.totalPrice, 0) : 0.00;
      const totalQuantity = cartData ? cartData.reduce((sum, item: any) => sum + item.quantity, 0) : 0;
      let orderItems: any[] = [];
      cartData.forEach((item: any) => {
        let orderItem: any =
        {
          "orderItemId": 0,
          "product": {
            "productId": item.product.productId,
            "productName": item.product.productName,
            "salePrice": item.unitPrice
          },
          "quantity": item.quantity,
          "unitPrice": item.unitPrice,
          "totalPrice": item.totalPrice
        }
        orderItems.push(orderItem);
      })

      let order: any = {
        "orderId": 0,
        "cartId": cartId,
        "customerId": localStorage.getItem("customerId"),
        "shippingAddressId": addressId,
        "billingAddressId": addressId,
        "totalAmount": totalAmount,
        "orderItems": orderItems
      }

      const response = await dispatch(createOrder(order)).unwrap();
      if (response) {
        handlePayment(response, navigate);
      }
    }
  };

  return (
    <>
      <Header />
      <Container disableGutters={false} maxWidth={false} sx={{ marginTop: 15, maxWidth: '1400px' }}>
        <Box sx={{ marginTop: 1 }}>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, md: 8 }} >
              <Address showActions={false} setDeliveryAddress={setDeliveryAddress} />
              {/* ............................................. */}
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <OrderSummary cartData={cartData} buttonText={"PROCEED TO PAYMENT"}
                handleNavigation={placeOrder} showCombo={false}
                enableButton={addressId! && addressId != ""} />
            </Grid2>
          </Grid2>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default ConfirmOrder;

